import {APPROVE_REQUEST_SUCCESS} from "../../enums/Employees/employees.types";

export const approveRequestSuccessAction = (uid) => {
    return {
        type: APPROVE_REQUEST_SUCCESS,
        payload: uid,
    };
};
